import { styled } from '@linaria/react';
import { layout, space } from '../../theme/tokens';

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space[5]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
